const INVOICE_UPLOAD_DROPZONE_CLASS_NAME = 'invoice-upload-dropzone';

export default INVOICE_UPLOAD_DROPZONE_CLASS_NAME;
